import { memo, useCallback } from 'react';
import { MdTune } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonGroup, Dropdown } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { setAutoExpandOfferRows } from '../../../../../reducers/gerenciadorPrecos/offerDataView';
import {
  QuickActionPriceTypeFilter as QuickActionPriceTypeFilterValue,
  selectorQuickActionFilters,
  setQuickActionPriceTypeFilter,
  toggleQuickActionPriceTypeFilter,
} from '../../../../../reducers/gerenciadorPrecos/quickActionsFilter';
import { IconButton } from '../QuickActionFilter';
import styles from './QuickActionPriceTypeFilter.module.scss';

const PRICE_TYPE_OPTIONS: { label: string; value: QuickActionPriceTypeFilterValue }[] = [
  {
    label: 'Preço regular (padrão)',
    value: 'REGULAR',
  },
  {
    label: 'Preço oferta',
    value: 'OFFER',
  },
];

export const QuickActionPriceTypeFilter = () => {
  const dispatch = useDispatch();
  const basicConfig = useSelector((state: RootState) => state.reducerIPA.basicConfig);
  const { priceTypeFilter, priceTypeFilterIsActive } = useSelector(selectorQuickActionFilters);

  const isFarmaClient = basicConfig?.competitorsDays.offer_channels_config_dto?.enabled ?? false;
  const skin = priceTypeFilterIsActive ? 'primary' : 'neutral';

  const handleSelect = useCallback(
    (value: unknown) => {
      if (value !== 'REGULAR' && value !== 'OFFER') return;

      dispatch(setQuickActionPriceTypeFilter(value));

      if (value === 'OFFER') {
        dispatch(setAutoExpandOfferRows(false));
      }
    },
    [dispatch],
  );

  const handleMainClick = useCallback(() => {
    dispatch(toggleQuickActionPriceTypeFilter());
  }, [dispatch]);

  if (!isFarmaClient) return null;

  return (
    <ButtonGroup className="quick-action-filter__button__container quick-action-filter__toggle" data-testid="quick-action-price-type-filter">
      <IconButton
        icon={<MdTune />}
        placeholder="Aplicar filtro rápido com preço regular"
        skin={skin}
        aria-label="Aplicar filtro rápido com preço regular"
        onClick={handleMainClick}
      />
      <Dropdown
        className={styles.container}
        menuClassName={styles.menu}
        menuStyle={{ width: 382, padding: 0 }}
        placement="bottomStart"
        renderTitle={() => (
          <IconButton icon="MdKeyboardArrowDown" className="quick-action-filter__toggle__arrow" skin={skin} aria-label="Abrir tipo de preço" />
        )}
      >
        <Dropdown.Item panel className={styles.panel}>
          <p className={styles.title}>Aplicar filtros rápidos</p>
          <div className={styles.options} role="radiogroup" aria-label="Aplicar filtros rápidos">
            {PRICE_TYPE_OPTIONS.map(({ label, value }) => (
              <button
                key={value}
                type="button"
                className={styles.option}
                role="radio"
                aria-checked={value === priceTypeFilter}
                onClick={() => handleSelect(value)}
              >
                <span className={styles.radio} aria-hidden="true" />
                <span className={value === priceTypeFilter ? styles['option-label-selected'] : styles['option-label']}>{label}</span>
              </button>
            ))}
          </div>
        </Dropdown.Item>
      </Dropdown>
    </ButtonGroup>
  );
};

export default memo(QuickActionPriceTypeFilter);
